<template>
  <div class="w-full h-full rounded-[19px] overflow-hidden" >
    <Vue3Calendly :url="url" class="w-full h-full calendly-height"  />
  </div>
</template>

<script>
import { Vue3Calendly } from 'vue3-calendly'

export default {
  name: 'Calendly',
  components: { Vue3Calendly },
  props: {
    url: {
      type: String,
      default: 'https://calendly.com/myqampus-support/30min',
    },
  },
}
</script>

<style scoped>
.calendly-height {
  height: 100% !important;
}
::v-deep .spinner {
  display: none !important;
}
</style>
